export default {
  links: {
    type: String,
    required: true
  },
  countryRegsiter: {
    type: String,
    default: null
  },
  state: {
    type: String,
    defsult: null
  },
  documentState: {
    type: String,
    default: null
  }
}



// WEBPACK FOOTER //
// ./src/app/patient/loading-page/components/links-profile/resources/props.js